// Reporter Agent API — drops a job message into the reporter pipeline
// via the same AppSync endpoint as the Ad Agency, using jobType "TRIGGER_REPORTER_JOB".
// The AppSync resolver routes this to reporter-agent-queue → TriggerStepFunction → reporter-agent-sfn.
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { TRIGGER_AD_AGENCY_JOB_MUTATION } from "../queries/libraryCardQueries";
import { getAuthToken } from "../utils/authUtils";

const GRAPHQL_ENDPOINT = "https://m2jxbyhagffjthxtsiuwb2iiwe.appsync-api.us-east-1.amazonaws.com/graphql";

const httpLink = createHttpLink({ uri: GRAPHQL_ENDPOINT });

const authLink = setContext((_, { headers }) => {
  const token = getAuthToken();
  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: token } : {}),
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

// Sends the full SFN input as the payload.
// Expected payload shape: { ticketId, tenantId, topic, tone, publicationTypes }
export const triggerReporterRunApi = async (payload) => {
  const { data } = await client.mutate({
    mutation: TRIGGER_AD_AGENCY_JOB_MUTATION,
    variables: {
      input: {
        jobType: "TRIGGER_REPORTER_JOB",
        tenantId: payload.tenantId,
        payload: JSON.stringify(payload),
      },
    },
  });
  return data.triggerAdAgencyJob;
};
